import { DeleteData, GetOptData, UpdateData, IsNotNull, GetAllData, CreateData, GetData, getCurrentUser } from '../commons/helper';

const userAll = async (b) => {
  let result = { data: [], tp: 1 };
  let url = process.env.REACT_APP_API_URL + "user-all";
  let tmpSC = '';
  tmpSC = b.p4.column === "Username" ? "a.acc_username" : tmpSC;
  tmpSC = b.p4.column === "Group" ? "g_name" : tmpSC;
  tmpSC = b.p4.column === "Status" ? "a.acc_status" : tmpSC;
  tmpSC = b.p4.column === "Roles" ? "roles_name" : tmpSC;
  tmpSC = b.p4.column === "Email" ? "a.acc_email" : tmpSC;
  b.p4.column = tmpSC
  await GetAllData(b, url).then(x => { result = x })
  return result;
}

const createUser = async (b) => {
  let result = { code: 'C-00', status: false, message: '' };
  let url = process.env.REACT_APP_API_URL + "user-create";
  await CreateData(b, url).then(x => { result = x })
  return result;
}

const deleteUser = async (b) => {
  let result = { code: 'D-00', status: false, message: '' };
  let url = process.env.REACT_APP_API_URL + "user-delete";
  await DeleteData(b, url).then(x => { result = x })
  return result;
}

const updateUser = async (b) => {
  let result = { code: 'U-00', status: false, message: '' };
  let url = process.env.REACT_APP_API_URL + "user-update";
  await UpdateData(b, url).then(x => { result = x })
  return result;
}

const resetPwd = async (b) => {
  b.p1 = IsNotNull(b.p1) ? b.p1 : await getCurrentUser();
  let result = { code: 'U-00', status: false, message: '' };
  let url = process.env.REACT_APP_API_URL + "user-rst-pwd";
  await UpdateData(b, url).then(x => { result = x })
  return result;
}

const getUserBarOptions = async () => {
  let result = null
  let url = process.env.REACT_APP_API_URL + "user-bar-opt"
  await GetOptData(url).then(x => { result = IsNotNull(x) ? x : null })
  return result;
}

export {
  userAll,
  createUser,
  deleteUser,
  updateUser,
  resetPwd,
  getUserBarOptions
}